import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DatabaseManagement from './management/management.component';
import DatabaseDesign from './design/design.component';
import DatabaseCoding from './coding/coding.component';
import DatabaseReporting from './Reporting/reporting.component';

const DatabaseServices = () => {
  return (
    <div className="database-services">
      <Routes>
        <Route path="management" element={<DatabaseManagement />} />
        <Route path="design" element={<DatabaseDesign />} />
        <Route path="coding" element={<DatabaseCoding />} />
        <Route path="reporting" element={<DatabaseReporting />} />
      </Routes>
    </div>
  );
};

export default DatabaseServices;
